import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Button, FloatButton, Layout } from 'antd';

import INTERNAL_LINKS from '../../enums/InternalLinks';
import React from 'react';
import UserLoginForm from '../UserLoginForm';
import UserRecoverPasswordForm from '../UserRecoverPasswordForm';
import UserEmailForm from '../UserEmailForm';
import UserVerify from '../UserVerify';
import PublicAnnouncement from '../../pages/PublicAnnouncement';
import { Content } from 'antd/es/layout/layout';
import UserAuthorizeForm from '../UserAuthorizeForm';

import './style.scss';
import { CompatRouter } from 'react-router-dom-v5-compat';
import DocumentVerification from '../../pages/PublicDocumentVerification';

export default class PublicLayout extends React.Component {
  render() {
    return (
      <Layout className={'public-layout'}>
        <Router>
          <CompatRouter>
            <Content className={'public-page-content'}>
              <Switch>
                <Route
                  exact
                  component={() => {
                    return <UserLoginForm />;
                  }}
                  path={INTERNAL_LINKS.HOME}
                />
                <Route
                  exact
                  component={(props) => {
                    return <UserRecoverPasswordForm {...props} />;
                  }}
                  path={INTERNAL_LINKS.RECOVER_PASSWORD}
                />
                <Route
                  exact
                  component={() => {
                    return <UserEmailForm />;
                  }}
                  path={INTERNAL_LINKS.RECOVER_EMAIL}
                />
                <Route
                  exact
                  component={() => {
                    return <UserAuthorizeForm />;
                  }}
                  path={INTERNAL_LINKS.REGISTER}
                />
                <Route
                  exact
                  component={(props) => {
                    return <UserVerify {...props} />;
                  }}
                  path={INTERNAL_LINKS.VERIFY}
                />
                <Route
                  exact
                  component={(props) => {
                    return <DocumentVerification {...props} />;
                  }}
                  path={INTERNAL_LINKS.DOCUMENT_VERIFICATION}
                />
                <Route
                  exact
                  component={(props) => {
                    return <PublicAnnouncement {...props} />;
                  }}
                  path={`${INTERNAL_LINKS.PUBLIC_ANNOUNCEMENT}/:announcement_id`}
                />
              </Switch>
              <div className="footer">
                <p>
                  &copy; {new Date().getFullYear()} Todos los derechos
                  reservados Corpoeducación.
                </p>
              </div>
            </Content>
          </CompatRouter>
        </Router>
        <FloatButton.BackTop>
          <Button>Arriba</Button>
        </FloatButton.BackTop>
      </Layout>
    );
  }
}
